import React from "react";
import { motion } from "framer-motion";
import { Beaker, Package, ShieldCheck, Layers, FlaskConical, ArrowUpRight } from "lucide-react";
import { Reveal, RevealGroup, RevealItem } from "@/components/motion/Reveal";

const services = [
  { icon: <FlaskConical className="w-6 h-6" />, title: "Fabricación propia y marca blanca", desc: "Fabricamos tu marca —propia o de terceros— desde el desarrollo del producto hasta el pallet listo para vender. Enfoque 100% B2B con partnership a largo plazo.", tag: "Fabricación B2B", span: "lg:col-span-2 lg:row-span-2", featured: true, image: "/images/servicios-bodegon-v2.jpg", imageMobile: "/images/servicios-mobile-v2.jpg" },
  { icon: <Beaker className="w-6 h-6" />, title: "I+D y formulación", desc: "Departamento propio que diseña fórmulas eficaces, saborizadas y estables, a medida de cada marca.", tag: "Dossier técnico" },
  { icon: <ShieldCheck className="w-6 h-6" />, title: "Calidad GMP", desc: "Fabricación auditada bajo normativa GMP con control y trazabilidad completa por lote.", tag: "GMP · FDA" },
  { icon: <Package className="w-6 h-6" />, title: "Envasado personalizado", desc: "Botes PET/PP/HDPE, doypacks, sobres monodosis y cajas con diseño de marca.", tag: "Multiformato" },
  { icon: <Layers className="w-6 h-6" />, title: "Marketing y diseño", desc: "Asesoramiento en packaging, imagen de marca y diseño de etiqueta.", tag: "Branding incluido" },
];

export default function Services() {
  return (
    <section id="servicios" className="relative py-10 md:py-14 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.3em] text-[#0A84E2] font-semibold mb-4">/ 02 · Servicios</div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0A1628] uppercase tracking-tighter leading-[1]">
              Todo lo que necesita tu marca,
              <br />
              <span className="text-slate-400">bajo un mismo techo.</span>
            </h2>
          </div>
          <p className="max-w-md text-slate-600">Desde la primera idea hasta el pallet cargado en tu almacén. Servicio 360º para marcas de nutrición deportiva.</p>
        </Reveal>

        <RevealGroup stagger={0.07} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-[minmax(240px,auto)]">
          {services.map((s, i) => (
            <RevealItem
              key={i}
              className={s.span || ""}
            >
            <motion.div
              whileHover={{ y: -5 }}
              transition={{ type: "spring", stiffness: 300, damping: 22 }}
              data-testid={`service-card-${i}`}
              className={`corp-card group relative overflow-hidden rounded-sm flex flex-col h-full ${s.featured ? "!border-[#0A84E2] text-white !bg-[#0A1628] lg:!bg-transparent lg:justify-between lg:p-8" : "p-6 md:p-8 justify-between"}`}
            >
              {s.featured && (
                <>
                  <img
                    src={s.imageMobile}
                    alt={s.title}
                    className="w-full h-56 object-cover shrink-0 lg:hidden"
                  />
                  <img
                    src={s.image}
                    alt={s.title}
                    className="hidden lg:block lg:absolute lg:inset-0 lg:h-full lg:w-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </>
              )}
              <div className={`relative flex items-start justify-between ${s.featured ? "p-6 pb-0 lg:p-0" : ""}`}>
                <div className={`w-11 h-11 flex items-center justify-center rounded-sm ${s.featured ? "bg-white/15 text-white backdrop-blur-sm" : "bg-[#EFF6FF] text-[#0A84E2]"}`}>
                  {s.icon}
                </div>
                <ArrowUpRight className={`w-5 h-5 ${s.featured ? "text-white/70" : "text-slate-300 group-hover:text-[#0A84E2]"} transition-colors`} />
              </div>
              <div className={`relative ${s.featured ? "px-6 pb-6 pt-4 lg:p-0" : ""}`}>
                <h3 className={`font-display font-semibold ${s.featured ? "text-2xl md:text-3xl text-white" : "text-lg md:text-xl text-[#0A1628]"} leading-tight`}>
                  {s.title}
                </h3>
                <p className={`mt-3 ${s.featured ? "text-base text-blue-50" : "text-sm text-slate-600"} leading-relaxed`}>
                  {s.desc}
                </p>
                <div className={`mt-5 inline-block text-[10px] uppercase tracking-widest font-semibold px-2 py-1 rounded-sm ${s.featured ? "text-white bg-white/20 border border-white/30" : "text-[#086AB7] border border-[#0A84E2]/30 bg-[#EFF6FF]"}`}>
                  {s.tag}
                </div>
              </div>
            </motion.div>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}
